module.exports = __webpack_public_path__ + "static/media/sociana1.5ba75488.png";